// DOM helper for strict element retrieval in playground modules.
// Example: getElement<HTMLTextAreaElement>('luisInput').

// Strict element getter that fails fast for missing required nodes.
export function getElement<T extends HTMLElement>(id: string): T {
  const element = document.getElementById(id)
  // Fail fast because this element is required for playground startup.
  if (!element) {
    throw new Error(`Missing element: ${id}`)
  } else {
    // Return typed element when id lookup succeeds.
    return element as T
  }
}
